import React from "react";
import { FaPhone, FaUsers, FaShieldAlt, FaChartLine, FaTachometerAlt, FaAward } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useInView } from "../../../hooks/useInView";
import SkeletonCard from "../../../components/SkeletonCard/SkeletonCard";
import ParticleBackground from "../../../components/ParticleBackground/ParticleBackground";

const HomeTwoWhyChooseUs = () => {
  const [ref, isInView] = useInView({ threshold: 0.1 });
  const benefits = [
    {
      icon: <FaChartLine />,
      title: "Consistent Activation Volume",
      description: "60–90+ activations per month per vendor",
      color: "blue-2-color"
    },
    {
      icon: <FaPhone />,
      title: "Fully Recorded & Audited Calls",
      description: "100% call recording with complete QA oversight",
      color: "green-4-color"
    },
    {
      icon: <FaUsers />,
      title: "Experienced Telecom Sales Teams",
      description: "Trained professionals who understand your industry",
      color: "pink-color"
    },
    {
      icon: <FaTachometerAlt />,
      title: "Scalable Call Center Capabilities",
      description: "Grow your operations on demand without friction",
      color: "orange-color"
    },
    {
      icon: <FaShieldAlt />,
      title: "Compliance-Driven Processes",
      description: "TCPA compliant workflows and strict adherence",
      color: "blue-2-color"
    },
    {
      icon: <FaAward />,
      title: "Multi-channel Lead Generation",
      description: "SEO, paid ads, social media, and more",
      color: "green-4-color"
    },
  ];

  return (
    <>
      <section ref={ref} className="achievement__area pt-115 pb-85 glassmorphic-section" style={{ position: 'relative', overflow: 'hidden' }}>
        <ParticleBackground id="benefits-particles" variant="mixed" />
        <div className="container">
          {/* Section Header */}
          <div className="row mb-55">
            <div className="col-xl-8 offset-xl-2">
              <div className="section__title section__title-3 text-center">
                <span>Why VectorTechSol?</span>
                <h2>Why Partners Choose Us</h2>
                <p className="mt-20">
                  We deliver consistent results through experienced teams, proven processes,
                  and unwavering commitment to compliance and quality.
                </p>
              </div>
            </div>
          </div>

          {/* Benefits Grid */}
          <div className="row">
            {!isInView ? (
              // Show skeleton loaders while not in view
              Array.from({ length: 6 }).map((_, index) => (
                <div key={index} className="col-xl-4 col-lg-6 col-md-6">
                  <SkeletonCard type="achievement" />
                </div>
              ))
            ) : (
              // Show actual content when in view
              benefits.map((benefit, index) => (
                <div key={index} className="col-xl-4 col-lg-6 col-md-6">
                  <div className="achievement__item text-center white-bg mb-30 content-loaded">
                    <div className="achievement__icon mb-20">
                      <i className={benefit.color} style={{ fontSize: '48px' }}>
                        {benefit.icon}
                      </i>
                    </div>
                    <h3 className="mb-15">{benefit.title}</h3>
                    <p>{benefit.description}</p>
                  </div>
                </div>
              ))
            )}
          </div>

          {/* Bottom CTA */}
          <div className="row mt-40">
            <div className="col-xl-8 offset-xl-2 text-center">
              <p className="mb-30" style={{ fontSize: '17px', fontWeight: '500', lineHeight: '1.8' }}>
                Ready to scale your business with a trusted partner?
              </p>
              <Link
                to="/contact-us"
                className="z-btn"
                style={{
                  padding: '16px 40px',
                  fontSize: '16px',
                  fontWeight: '600',
                  letterSpacing: '0.5px',
                  borderRadius: '12px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  minWidth: '220px'
                }}
              >
                Get Started Today
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeTwoWhyChooseUs;
